import React from "react"
import { Link } from "gatsby"

const PrevNext = ({ prev, next }) => {
  return (
    <ul className="c-pnNav">
      {prev && (
        <li className="c-pnNav__item -prev">
          <Link
            to={`/${prev.parent.name}/`}
            rel="http://prev"
            className="c-pnNav__link u-flex--aic"
          >
            <svg
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              className="arkhe-svg-chevron-left c-pnNav__svg"
              width="1em"
              height="1em"
              viewBox="0 0 40 40"
              role="img"
              aria-hidden="true"
              focusable="false"
            >
              <path d="M27,32l-2.1,2.1L11.1,20.3c-0.2-0.2-0.2-0.5,0-0.7L24.9,5.9L27,8L16,20L27,32z" />
            </svg>
            <span className="c-pnNav__title">{prev.frontmatter.title}</span>
          </Link>
        </li>
      )}
      {next && (
        <li className="c-pnNav__item -next">
          <Link
            to={`/${next.parent.name}/`}
            rel="http://next"
            className="c-pnNav__link u-flex--aic"
          >
            <svg
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              className="arkhe-svg-chevron-right c-pnNav__svg"
              width="1em"
              height="1em"
              viewBox="0 0 40 40"
              role="img"
              aria-hidden="true"
              focusable="false"
            >
              <path d="M13,8l2.1-2.1l13.8,13.8c0.2,0.2,0.2,0.5,0,0.7L15.1,34.1L13,32l11-12L13,8z" />
            </svg>
            <span className="c-pnNav__title">{next.frontmatter.title}</span>
          </Link>
        </li>
      )}
    </ul>
  )
}

export default PrevNext
